module.exports = __webpack_public_path__ + "static/media/008-Fenster_ID_Start.258aa23d.mp3";